import { usePage } from '@inertiajs/vue3'
import { h, watch } from 'vue'
import type { PageProps } from '~/types/inertia'

export function useFlash() {
  const page = usePage<PageProps>()
  const toast = useToast()

  watch(
    () => page.props.flash,
    (flash) => {
      if (!flash || Object.keys(flash).length === 0) {
        return
      }

      if (flash.alert) {
        toast.add({
          title: h('span', { innerHTML: flash.alert }),
          color: 'warning'
        })
      } else if (flash.notice) {
        toast.add({
          title: flash.notice,
          color: 'neutral'
        })
      }
    },
    { immediate: true }
  )
}
